import { useState } from "react";
import { MdAdd } from "react-icons/md";
import { toast } from "react-toastify";
import { useAddSubCategoryMutation } from "../../../features/api/subcategoryApi";

const AddSubCategory = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [addSubCategory] = useAddSubCategoryMutation();

  const [sub_catName, setSubCategoryName] = useState("");
  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const newSubCategory = {
        sub_catName,
      };
      const response = await addSubCategory(newSubCategory);

      if (response?.data) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Brand create success...!!!");
      } else if (response?.error) {
        setIsOpen(false);
        toast.error("Create brand failed...!!!");
      }
    } catch (error) {
      console.error("Error create data:", error);
    }
  };
  return (
    <div>
      <span
        onClick={openModal}
        className="flex items-center p-1 text-white rounded-sm bg-blue-500 font-medium text-sm cursor-pointer"
      >
        <MdAdd size={20} /> New Brand
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-slate-200 p-6 rounded shadow-md md:w-[400px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4 ">
              <div className="card-body">
                <h1 className="text-lg font-medium">Create Brand</h1>
                <form
                  onSubmit={handleAdd}
                  className="flex flex-col items-start font-extralight my-2"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="flex flex-col gap-4 w-full">
                    <input
                      type="text"
                      onChange={(e) => setSubCategoryName(e.target.value)}
                      className="border pl-1 h-8 focus:outline-none border-gray-400 rounded-sm"
                    />
                  </div>
                  <button
                    type="submit"
                    className="bg-blue-500 text-white font-bold mt-4 px-4 rounded block m-auto"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddSubCategory;
